import * as Sentry from "@sentry/react";
import { createFileRoute } from "@tanstack/react-router";
import { useAuth0Login } from "~/hooks/useAuth0Login";
import { PersonalisationModal, ApplicationsView } from "~/components/dashboard";
import { dashboardSearchSchema } from "~/utils/validation-schemas";
import { Spinner } from "~/components/ui/spinner";

export const Route = createFileRoute("/$tenantSlug/_protected/dashboard")({
  component: TenantDashboardPage,
  validateSearch: dashboardSearchSchema,
});

function TenantDashboardPage() {
  const { isAuthenticated, isLoading } = useAuth0Login();
  Sentry.logger.info("TenantDashboardPage loaded", { isAuthenticated });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <Spinner className="size-8 text-brand-green-primary" />
      </div>
    );
  }

  return (
    <div className="bg-gray-50">
      {isAuthenticated && <PersonalisationModal />}
      <div className="max-w-7xl mx-auto p-6">
        <ApplicationsView />
      </div>
    </div>
  );
}
